import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
{
    id: "po-06-h6v0-01",
    name: "PO 01 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 39, y: 129, width: 490, height: 389, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 39, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 628, y: 173, width: 447, height: 335, rotation: 0, imageRotation: 0 },
            { id: "5", x: 628, y: 516, width: 220, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 516, width: 220, height: 166, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h6v0-02",
    name: "PO 02 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 129, width: 490, height: 389, rotation: 0, imageRotation: 0 },
        { id: "2", x: 39, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "4", x: 607, y: 129, width: 490, height: 389, rotation: 0, imageRotation: 0 },
        { id: "5", x: 607, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "6", x: 856, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-03",
    name: "PO 03 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 129, width: 490, height: 389, rotation: 0, imageRotation: 0 },
        { id: "2", x: 39, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 526, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "4", x: 607, y: 336, width: 490, height: 389, rotation: 0, imageRotation: 0 },
        { id: "5", x: 607, y: 128, width: 241, height: 200, rotation: 0, imageRotation: 0 },
        { id: "6", x: 856, y: 128, width: 241, height: 200, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-04",
    name: "PO 04 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 129, y: 75, width: 310, height: 230, rotation: 0, imageRotation: 0 },
        { id: "2", x: 129, y: 313, width: 310, height: 229, rotation: 0, imageRotation: 0 },
        { id: "3", x: 129, y: 550, width: 310, height: 229, rotation: 0, imageRotation: 0 },
        { id: "4", x: 697, y: 75, width: 310, height: 230, rotation: 0, imageRotation: 0 },
        { id: "5", x: 697, y: 313, width: 310, height: 229, rotation: 0, imageRotation: 0 },
        { id: "6", x: 697, y: 550, width: 310, height: 229, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-05",
    name: "PO 05 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 255, y: 75, width: 309, height: 230, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 75, width: 309, height: 230, rotation: 0, imageRotation: 0 },
        { id: "3", x: 255, y: 313, width: 309, height: 229, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 313, width: 309, height: 229, rotation: 0, imageRotation: 0 },
        { id: "5", x: 255, y: 550, width: 309, height: 229, rotation: 0, imageRotation: 0 },
        { id: "6", x: 572, y: 550, width: 309, height: 229, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-06",
    name: "PO 06 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 97, y: 0, width: 375, height: 280, rotation: 0, imageRotation: 0 },
        { id: "2", x: 97, y: 288, width: 375, height: 279, rotation: 0, imageRotation: 0 },
        { id: "3", x: 97, y: 575, width: 375, height: 279, rotation: 0, imageRotation: 0 },
        { id: "4", x: 665, y: 0, width: 375, height: 280, rotation: 0, imageRotation: 0 },
        { id: "5", x: 665, y: 288, width: 375, height: 279, rotation: 0, imageRotation: 0 },
        { id: "6", x: 665, y: 575, width: 375, height: 279, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-07",
    name: "PO 07 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 43, y: 203, width: 275, height: 220, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 431, width: 275, height: 220, rotation: 0, imageRotation: 0 },
        { id: "3", x: 326, y: 203, width: 575, height: 448, rotation: 0, imageRotation: 0 },
        { id: "4", x: 909, y: 203, width: 184, height: 144, rotation: 0, imageRotation: 0 },
        { id: "5", x: 909, y: 355, width: 184, height: 144, rotation: 0, imageRotation: 0 },
        { id: "6", x: 909, y: 507, width: 184, height: 144, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-08",
    name: "PO 08 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 42, y: 156, width: 346, height: 268, rotation: 0, imageRotation: 0 },
        { id: "2", x: 396, y: 156, width: 345, height: 268, rotation: 0, imageRotation: 0 },
        { id: "3", x: 749, y: 156, width: 345, height: 268, rotation: 0, imageRotation: 0 },
        { id: "4", x: 42, y: 432, width: 346, height: 267, rotation: 0, imageRotation: 0 },
        { id: "5", x: 396, y: 432, width: 345, height: 267, rotation: 0, imageRotation: 0 },
        { id: "6", x: 749, y: 432, width: 345, height: 267, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-09",
    name: "PO 09 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 172, width: 564, height: 509, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 172, width: 215, height: 165, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 345, width: 215, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 517, width: 215, height: 164, rotation: 0, imageRotation: 0 },
        { id: "5", x: 795, y: 172, width: 341, height: 251, rotation: 0, imageRotation: 0 },
        { id: "6", x: 795, y: 431, width: 341, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h6v0-10",
    name: "PO 10 - H6V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 271, width: 374, height: 312, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 382, y: 271, width: 183, height: 152, rotation: 0, imageRotation: 0 },
        { id: "3", x: 382, y: 431, width: 183, height: 152, rotation: 0, imageRotation: 0 },
        { id: "4", x: 573, y: 271, width: 182, height: 152, rotation: 0, imageRotation: 0 },
        { id: "5", x: 573, y: 431, width: 182, height: 152, rotation: 0, imageRotation: 0 },
        { id: "6", x: 763, y: 271, width: 373, height: 312, rotation: 0, imageRotation: 0 },
    ],
}
];